import { useEffect } from 'react';

// Hook personalizado para habilitar atalhos de teclado
export const useKeyboardShortcuts = () => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Verifica se é um campo de texto ou área de texto
      const isTextField = e.target.tagName === 'INPUT' || 
                         e.target.tagName === 'TEXTAREA' ||
                         e.target.contentEditable === 'true';

      // Se for um campo de texto, permite todos os atalhos padrão
      if (isTextField) {
        return true;
      }

      // Para outros elementos, verifica os atalhos específicos
      if (e.ctrlKey || e.metaKey) {
        switch (e.key.toLowerCase()) {
          case 'a': // Selecionar tudo
          case 'c': // Copiar
          case 'v': // Colar
          case 'x': // Recortar
          case 'z': // Desfazer
          case 'y': // Refazer
            return true;
          default:
            return false;
        }
      }
    };

    // Adiciona o listener
    document.addEventListener('keydown', handleKeyDown);

    // Remove o listener quando o componente for desmontado
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
};

// Função para habilitar atalhos em um elemento específico
export const enableShortcuts = (element) => {
  if (!element) return;

  element.addEventListener('keydown', (e) => {
    if (e.ctrlKey || e.metaKey) {
      switch (e.key.toLowerCase()) {
        case 'a':
        case 'c':
        case 'v':
        case 'x':
          e.stopPropagation();
          return true;
        default:
          return false;
      }
    }
  });
}; 